import React, { useContext } from 'react';
import UserSelfContext from '../utils/self-context';
import InputComponent from './Input';
import {
	DATA_FIELD_TYPE_TEXT,
	DATA_FIELD_TYPE_TEXTAREA,
	DATA_FIELD_TYPE_DATE,
	DATA_FIELD_TYPE_MULTIPLE_SELECT,
	DATA_FIELD_TYPE_SINGLE_SELECT,
	DATA_FIELD_TYPE_NUMBER,
	DATA_FIELD_TYPE_SWITCH,
	DATA_FIELD_TYPE_DATETIME
} from '../utils/constants';

const EDITABLE_TYPE_MAP = {
	[DATA_FIELD_TYPE_TEXT]: 'input',
	[DATA_FIELD_TYPE_TEXTAREA]: 'text',
	[DATA_FIELD_TYPE_DATE]: 'date',
	[DATA_FIELD_TYPE_NUMBER]: 'number',
	[DATA_FIELD_TYPE_DATETIME]: 'datetime',
	[DATA_FIELD_TYPE_SWITCH]: 'switch',
	[DATA_FIELD_TYPE_SINGLE_SELECT]: 'select',
	[DATA_FIELD_TYPE_MULTIPLE_SELECT]: 'multiple_select'
};

const getEditableProps = ({
	field,
	model
}) => {
	const { key, type } = field;
	switch (type) {
	case DATA_FIELD_TYPE_DATE:
		return {
			initialValue: model[`custom_${key}`] ? new Date(model[`custom_${key}`]) : null
		};
	case DATA_FIELD_TYPE_DATETIME:
		return {
			initialValue: model[`custom_${key}`] ? new Date(model[`custom_${key}`]) : null
		};
	case DATA_FIELD_TYPE_SWITCH:
		return {
			initialValue: !!model[`custom_${key}`]
		};
	case DATA_FIELD_TYPE_SINGLE_SELECT:
		return {
			options: (field.options || []).map(t => ({ label: t, value: t })),
			initialValue: [model[`custom_${key}`]] || []
		};
	case DATA_FIELD_TYPE_MULTIPLE_SELECT:
		return {
			options: (field.options || []).map(t => ({ label: t, value: t })),
			initialValue: (model[`custom_${key}`] || []).map(v => ({ label: v, value: v }))
		};
	default:
		return { initialValue: model[`custom_${key}`] || null };
	}
};

const CustomFieldInputItem = (props) => {
	const { userSelf } = useContext(UserSelfContext);
	const {
		model,
		disabled,
		field,
		onSave
	} = props;

	const editableProps = getEditableProps({
		field,
		model,
		userSelf
	});

	return (
		<InputComponent
			placeholder={field.name}
			requiredRulesObjectType={field.object_type}
			onSave={async (values) => {
				const newValues = { ...values };

				if (field.type === DATA_FIELD_TYPE_MULTIPLE_SELECT) {
					newValues[`custom_${field.key}`] = values[`custom_${field.key}`].map(v => v.value);
				}

				await onSave(newValues);
			}}
			dataKey={`custom_${field.key}`}
			title={field.name}
			type={EDITABLE_TYPE_MAP[field.type]}
			disabled={disabled}
			{...editableProps}
		/>
	);
};

export default CustomFieldInputItem;
